import { useMemo } from 'react'

export const useCharactersLeft = (maxLength: number, charsEntered: number) => {
  return useMemo(() => {
    const charactersLeft = maxLength - (charsEntered ?? 0)

    if (charactersLeft < 0) {
      return `${Math.abs(charactersLeft)} Characters Over The Limit of ${maxLength}`
    }

    return `${charactersLeft} Characters Left`
  }, [maxLength, charsEntered])
}
